package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.article_component.mobile.mobile_waiter_tiles

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.draggable
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onDragEnd
import com.varabyte.kobweb.compose.ui.modifiers.onDragEnter
import com.varabyte.kobweb.compose.ui.modifiers.onDragStart
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.onTouchMove
import com.varabyte.kobweb.compose.ui.modifiers.onTouchStart
import com.varabyte.kobweb.compose.ui.modifiers.size
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.home.closing_reports.CurrencyTypeEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ArticleSortEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail.ArticleModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail.GetCategory
import org.jetbrains.compose.web.attributes.Draggable
import org.jetbrains.compose.web.css.LineStyle
import org.w3c.dom.get
import kotlin.js.Date

@Composable
fun MobileWaiterTilesLayout(
    productId: MutableState<String>,
    maxItems: Int,
    selectedCategory: GetCategory?,
    selectedArticleSortingId:String,
    listingLayoutsChunk: Int,
    manualItemsCount:Int,
    currencyType: CurrencyTypeEnum,
    showImgUrl: suspend (String) -> String,
    deleteGridProduct: (Int) -> Unit,
    setGridProduct: (String, Int) -> Unit,
    onReorder: (List<dynamic>, List<String>, List<Int>, List<String>) -> Unit
) {
    val dragState = remember { DragState() }
    val positionMap = remember(selectedCategory?.gridProducts) {
        selectedCategory?.gridProducts
            ?.sortedBy {
                when (selectedArticleSortingId) {
                    ArticleSortEnum.AUTO_BY_NUMBER.sortId -> it.position.toString()
                    ArticleSortEnum.AUTO_BY_NAME.sortId->it.product?.name
                    else -> ""
                }
            }
            ?.associateBy { it.position } ?: emptyMap()
    }

    (1..maxItems)
        .let { range ->
            if (selectedArticleSortingId == ArticleSortEnum.MANUAL.sortId) {
                range.take(manualItemsCount)
            } else {
                range.toList()
            }
        }.chunked(listingLayoutsChunk).forEach { rowPositions ->
        Row(
            horizontalArrangement = Arrangement.Start
        ) {
            rowPositions.forEach { position ->
                when (val model = positionMap[position]) {
                    null -> EmptyTileSlot(
                        position = position,
                        dragState = dragState,
                        productId = productId,
                        setGridProduct = setGridProduct
                    )
                    else -> DraggableTileItem(
                        position = position,
                        model = model,
                        dragState = dragState,
                        currencyType = currencyType,
                        showImgUrl = showImgUrl,
                        deleteGridProduct = deleteGridProduct,
                        onReorder = { from, to ->
                            handleTileReorder(
                                from = from,
                                to = to,
                                gridProducts = selectedCategory?.gridProducts ?: emptyList(),
                                onReorder = onReorder
                            )
                        }
                    )
                }
            }
        }
    }
}

private class DragState {
    var startPosition by mutableStateOf(-1)
    var hoverPosition by mutableStateOf(-1)
    var isDragging by mutableStateOf(false)
    var touchStartY by mutableStateOf(0f)
    var touchStartTime by mutableStateOf(0L)
}

@Composable
private fun DraggableTileItem(
    position: Int,
    model: ArticleModel,
    dragState: DragState,
    currencyType: CurrencyTypeEnum,
    showImgUrl: suspend (String) -> String,
    deleteGridProduct: (Int) -> Unit,
    onReorder: (Int, Int) -> Unit
) {
    Box(
        modifier = Modifier
            .draggable(Draggable.True)
            .applyDragHandlers(
                position = position,
                dragState = dragState,
                onReorderComplete = onReorder
            )
            .backgroundColor(
                if (position == dragState.hoverPosition && dragState.isDragging)
                    Theme.ActionSelected.rgb
                else Theme.Transparent.rgb
            )
    ) {
        MobileWaiterTilesTypeItem(
            model = model,
            currencyType = currencyType,
            showImgUrl = showImgUrl,
            deleteGridProduct = { deleteGridProduct(model.position) }
        )
    }
}

@Composable
private fun EmptyTileSlot(
    position: Int,
    dragState: DragState,
    productId: MutableState<String>,
    setGridProduct: (String, Int) -> Unit
) {
    Box(
        modifier = Modifier
            .emptyTileStyle()
            .backgroundColor(
                if (position == dragState.hoverPosition && dragState.isDragging)
                    Theme.ActionSelected.rgb
                else Theme.GrayAlpha02.rgb
            )
            .onDragEnter {
                if (dragState.isDragging) {
                    dragState.hoverPosition = position
                }
            }
            .onMouseOver {
                if (productId.value.isNotEmpty()) {
                    setGridProduct(productId.value, position)
                }
            }
            .onMouseLeave {
                productId.value = ""
            }
    )
}

private fun Modifier.emptyTileStyle() = this
    .margin(Dimen.semiSemiNormalPadding)
    .size(Dimen.mobileWaiterTilesTypeItemSize)
    .border(
        width = Dimen.smallThickness,
        style = LineStyle.Solid,
        color = Theme.ActionDisabledBackground.rgb
    )
    .borderRadius(Dimen.lowBorderRadius)

private fun Modifier.applyDragHandlers(
    position: Int,
    dragState: DragState,
    onReorderComplete: (Int, Int) -> Unit
) = this
    .onDragStart {
        dragState.startPosition = position
        dragState.isDragging = true
    }
    .onDragEnter {
        dragState.hoverPosition = position
    }
    .onDragEnd {
        if (dragState.startPosition != -1 &&
            dragState.hoverPosition != -1 &&
            dragState.startPosition != dragState.hoverPosition
        ) {
            onReorderComplete(dragState.startPosition, dragState.hoverPosition)
        }
        dragState.startPosition = -1
        dragState.hoverPosition = -1
        dragState.isDragging = false
    }
    .applyTouchHandlers(position, dragState)

private fun Modifier.applyTouchHandlers(
    position: Int,
    dragState: DragState
) = this
    .onTouchStart { event ->
        dragState.touchStartY = event.touches[0]?.clientY?.toFloat() ?: 0f
        dragState.touchStartTime = Date.now().toLong()
        dragState.startPosition = position
        dragState.isDragging = true
        event.preventDefault()
    }
    .onTouchMove { event ->
        if (dragState.isDragging) {
            val currentY = event.touches[0]?.clientY?.toFloat() ?: 0f
            val deltaY = currentY - dragState.touchStartY
            val itemHeight = Dimen.mobileWaiterTilesTypeItemSize.value
            val newPosition = (position + (deltaY / itemHeight).toInt())
            dragState.hoverPosition = newPosition
            event.preventDefault()
        }
    }

private fun handleTileReorder(
    from: Int,
    to: Int,
    gridProducts: List<ArticleModel>,
    onReorder: (List<dynamic>, List<String>, List<Int>, List<String>) -> Unit
) {
    val updatedProducts = gridProducts.map { product ->
        when (product.position) {
            from -> product.copy(position = to)
            in minOf(from, to)..maxOf(from, to) ->
                if (from < to) {
                    product.copy(position = product.position - 1)
                } else {
                    product.copy(position = product.position + 1)
                }
            else -> product
        }
    }

    val changedItems = updatedProducts.filter { product ->
        product.position in minOf(from, to)..maxOf(from, to)
    }

    onReorder(
        updatedProducts,
        changedItems.map { it.id },
        changedItems.map { it.position },
        changedItems.map { it.productId }
    )
}